import type { MetricsConstants } from '@/types/finance';

// Metrics location
export const METRICS_VALUE_LOC = 0;
export const METRICS_IS_EDIT_LOC = 1;
export const METRICS_LR_LOAD: MetricsConstants = 'LRLoad';
export const METRICS_OH_EXPENSES: MetricsConstants = 'OHExpenses';
export const METRICS_GWP_GROWTH: MetricsConstants = 'GWPGrowth';
